import request from './api';
import { API_CMS } from '../constants/api';

export const getPics = () =>
  request(`${API_CMS}images/breakfastpics`, {
    method: 'GET'
  });
